// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32M3O","inner":"Footer_inner__1ztYM","nextIcon":"Footer_nextIcon__2LKkz","innerLeft":"Footer_innerLeft__1oahh"};